<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-btn
                v-bind="activatorProps"
                id="boton-verde"
            >
                <v-icon>mdi mdi-plus</v-icon>
                <v-icon>mdi mdi-file-document</v-icon>
            </v-btn>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Agregar archivos a solicitud" style="text-align: center;" class="modal-header"></v-toolbar>
                <AgregarArchivosConTipo
                    class="mb-5 mr-5 ml-5"
                    @close="this.dialog = false; isActive.value = false"
                    @agregarArchivos="handleSubmit"
                    :autorizacionObligatoria="autorizacionObligatoria"
                    :ordenYAltaComplejidadObligatoria="ordenYAltaComplejidadObligatoria"
                    :tiposDocumentacion="tiposDocumentacion"
                    :archivosActuales="archivosActuales"
                >
                </AgregarArchivosConTipo>
            </v-card>
        </template>
    </v-dialog>
</template>


<style src="../assets/general.css"></style>

<script>
    import AgregarArchivosConTipo from './AgregarArchivosConTipo.vue';

    export default {
        components:{
            AgregarArchivosConTipo,
        },
        props: {
            autorizacionObligatoria: {
                type: Boolean,
                default: false,
            },
            ordenYAltaComplejidadObligatoria: {
                type: Boolean,
                default: false,
            },
            tiposDocumentacion: {
                type: Array,
                default: () => [],
            },
            archivosActuales: {
                type: Array,
                default: () => [],
            },
        },
        data: () => ({
            dialog: false,
        }),
        methods: {
            handleSubmit(archivos) {
                this.$emit('agregarArchivos', archivos);
                this.dialog = false;
            },
        },
    }
</script>